import { AssayModalAssayWithValuableConceptResponse } from '@/components/assays-view/services/assays-view-assay/assays-view-assay.dto'
import { CommonLaboratoryResponse, EnumResponse } from '@/api/services/common.dto'
import { Nullable } from '@/shared/types/app.types'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'

export interface ShipmentRulesModalBasicDataComboOptions {
    originStates: EnumResponse[],
    destinationStates: EnumResponse[],
    sampleTypes: CommonSampleTypeResponse[],
    topographicCodes: CommonTopographicCodeResponse[],
    assays: AssayModalAssayWithValuableConceptResponse[]
}

export interface ShipmentRulesModalBasicDataState {
    id: Nullable<number>,
    active: boolean,
    assay?: Partial<AssayModalAssayWithValuableConceptResponse>,
    caseOwnerLaboratory: Nullable<CommonLaboratoryResponse>,
    destinationEntityInternalStatus: Nullable<EnumResponse>,
    destinationLaboratory: Nullable<CommonLaboratoryResponse>,
    entityType: Nullable<EnumResponse>,
    originEntityInternalStatus: Nullable<EnumResponse>,
    originLaboratory: Nullable<CommonLaboratoryResponse>,
    priority?: number,
    sampleType?: CommonSampleTypeResponse,
    topographicCode?: CommonTopographicCodeResponse,
    comboOptions: ShipmentRulesModalBasicDataComboOptions
}
export const initialShipmentRulesModalBasicDataState =
    (): ShipmentRulesModalBasicDataState => ({
        id: null,
        active: true,
        caseOwnerLaboratory: null,
        destinationEntityInternalStatus: null,
        destinationLaboratory: null,
        entityType: null,
        originEntityInternalStatus: null,
        originLaboratory: null,
        priority: undefined,
        comboOptions: {
            originStates: [],
            destinationStates: [],
            sampleTypes: [],
            topographicCodes: [],
            assays: []
        }
    })
